import { useContext } from 'react';
import { PermissionContext } from '../contexts/PermissionContext';
import { adminRoles } from '../const/roles';

export const useIsPixotopeUser = () => {
  const { roles } = useContext(PermissionContext);

  return (roles ?? []).some((role) => adminRoles.some((adminRole) => adminRole.id === role.id));
};
